export const USER_LANGUAGE_CODES = {
  FRENCH: "fr",
  ENGLISH: "en-gb",
  SPANISH_MEXICO: "es-mx",
};
